import React, { createContext, useContext, useState } from "react";

const CartPageContext = createContext();

export const CartPageProvider = ({ children }) => {
    // const data = "Hii Cart"

    const [cartItems, setCartItems] = useState([
        {
          sku: "S-8719",
          productName: "Redken City Beats Acidic Conditioning Color Cream",
          brand: "REDKEN",
          color: "Magenta",
          size: "85ml",
          quantity: 150,
          counterPrice: 12.99,
          price: 195.99,
          image: "path/to/image1.jpg",
        },
        {
          sku: "S-8719",
          productName: "Redken City Beats Acidic Color Cream",
          brand: "REDKEN",
          color: "Magenta",
          size: "85ml",
          quantity: 150,
          counterPrice: 12.99,
          price: 195.99,
          image: "path/to/image2.jpg",
        },
        {
          sku: "S-8719",
          productName: "Redken Midtown",
          brand: "REDKEN",
          color: "Magenta",
          size: "85ml",
          quantity: 150,
          counterPrice: 12.99,
          price: 195.99,
          image: "path/to/image3.jpg",
        },
        {
          sku: "S-8719",
          productName: "Redken City Beats Acidic Conditioning Color Cream",
          brand: "REDKEN",
          color: "Magenta",
          size: "85ml",
          quantity: 150,
          counterPrice: 12.99,
          price: 195.99,
          image: "path/to/image4.jpg",
        },
      ]);
    
      const deleteItem = (index) => {
        setCartItems(cartItems.filter((_, i) => i !== index));
      };
    
      const deleteAllItems = () => {
        setCartItems([]);
      };
    

    return (
        <CartPageContext.Provider value={{ cartItems, setCartItems, deleteItem, deleteAllItems }}>
          {children}
        </CartPageContext.Provider>
      );
 
}

export const useCartPageContext = () => {
    const context = useContext(CartPageContext);
    if (context === undefined) {
      throw new Error('useCartPageContext must be used within a CartPageProvider');
    }
    return context;
  };